import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component'

import { LoginRecoverPasswdComponent } from './pages/login-recover-passwd/login-recover-passwd.component';
import { LoginRecoverPasswdCWComponent } from './pages/login-recover-passwd-cw/login-recover-passwd-cw.component';

import { LoginCubeWorksComponent } from './pages/login/login-cubeworks/login-cubeworks.component';
import { LoginUserTempComponent } from './pages/login/login-usertemp/login-usertemp.component';
import { MachineLearningImagesComponent } from './pages/machine-learning-images/machine-learning-images.component';
// import { EditProjectComponent } from './pages/sales-management/sales-project/edit-project/edit-project.component';
// import { DashboardCreateComponent } from './pages/dashboard/dashboard-create/dashboard-create.component'
// import { DashboardWidgetComponent } from './pages/dashboard/dashboard-widget/dashboard-widget.component'
import { WorkFlowTablesModule } from './pages/cubeWork/workflow-table/workflow-table.module';
import { CompanyRegistrationComponent } from './pages/login/company-registration/company-registration.component';

import { PublicRegistrationComponent } from './pages/public-registration/public-registration.component';



import { CompantNotificationEmailModule } from './pages/cubeWork/company-notification-email/company-notification-email.module';

const APP_ROUTES: Routes = [
  { path: '', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logincubeworks', component: LoginCubeWorksComponent },
  { path: 'loginUserTemp', component: LoginUserTempComponent },
  { path: 'CompanyRegistration', component: CompanyRegistrationComponent },
  { path: 'registration-form', component: PublicRegistrationComponent },
  { path: 'actPass', component: ResponsiveComponent },
  { path: 'RecoverPassword', component: LoginRecoverPasswdComponent },
  { path: 'RecoverPasswordCW', component: LoginRecoverPasswdCWComponent },
  // { path: 'imagesIA', component: MachineLearningImagesComponent},
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'management-command-center',
    loadChildren: () => import('./pages/management-command-center/management-command-center.module').then(m => m.ManagementCommandCenterModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./shared/shared-dashboard2/dashboard2.module').then(m => m.Dashboard2Module)
  },
  {
    path: 'salesProject',
    loadChildren: () => import('./pages/sales-management/sales-project/sales-project.module').then(m => m.SalesProjectModule)
  },
  {
    path: 'pipeline',
    loadChildren: () => import('./pages/sales-management/pipeline/pipeline.module').then(m => m.PipelineModule)
  },
  {
    path: 'salesLeads',
    loadChildren: () => import('./pages/sales-management/sales-leads/sales-lead.module').then(m => m.SalesLeadModule)
  },
  {
    path: 'contacts',
    loadChildren: () => import('./pages/sales-management/contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'comunicationboard',
    loadChildren: () => import('./pages/sales-management/comunication-board/comunication-board.module').then(m => m.ComunicationBoardModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('./pages/sales-management/customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'employeeActivity',
    loadChildren: () => import('./pages/sales-management/employee-activities/employee-activities.module').then(m => m.EmployeeActivitiesModule)
  },
  {
    path: 'salesanalysis',
    loadChildren: () => import('./pages/sales-management/sales-analysis/sales-analysis.module').then(m => m.SalesAnalysisModule)
  },
  {
    path: 'salesSite',
    loadChildren: () => import('./pages/sales-management/sales-site/sales-site.module').then(m => m.SalesSiteModule)
  },
  {
    path: 'NewEstimates',
    loadChildren: () => import('./pages/estimationNew/estimation.module').then(m => m.EstimationModule)
  },
  {
    path: 'Estimates',
    loadChildren: () => import('./pages/estimation/estimation.module').then(m => m.EstimationModule)
  },
  {
    path: 'EstimatesServiceContract',
    loadChildren: () => import('./pages/service-contract/service-contract.module').then(m => m.ServiceContractModule)
  },
  {
    path: 'taskManagement',
    loadChildren: './pages/project-management/task-management/task-management.module#TaskManagementModule'
  },
  {
    path: 'ganttScheduler',
    loadChildren: './pages/project-management/gantt-scheduler/gantt-scheduler.module#GanttSchedulerProjectModule'
  },
  {
    path: 'swo',
    loadChildren: './pages/service-management/service-work-order/service-work-order.module#ServiceWorkOrderModule'
  },
  {
    path: 'projectAnalysis',
    loadChildren: './pages/project-management/project-analysis/project-analysis.module#ProjectAnalysisModule'
  },
  {
    path: 'openRif',
    loadChildren: './pages/project-management/open-rif/open-rif.module#OpenRifModule'
  },
  {
    path: 'openPunchList',
    loadChildren: './pages/project-management/open-punch-list/open-punch-list.module#OpenPunchListModule'
  },
  {
    path: 'projects',
    loadChildren: './pages/project-management/projects/projects.module#ProjectsModule'
  },
  {
    path: 'myprojects',
    loadChildren: './pages/my-projects/my-projects.module#MyProjectsModule'
  },
  {
    path: 'commissioning',
    loadChildren: './pages/engineering/commissioning/commissioning.module#CommissioningModule'
  },
  {
    path: 'systemLibrary',
    loadChildren: './pages/engineering/system-library/system-library.module#SystemLibraryModule'
  },
  {
    path: 'myTrainings',
    loadChildren: './pages/home/my-trainings/my-trainings.module#MyTrainingsModule'
  },
  {
    path: 'pmUtility',
    loadChildren: './pages/service-management/pm-utility/pm-utility.module#PmUtilityModule'
  },
  {
    path: 'serviceSites',
    loadChildren: './pages/service-management/service-sites/service-sites.module#ServiceSitesModule'
  },
  {
    path: 'saleservicesites',
    loadChildren: './pages/service-management/sales-service-sites/sales-service-sites.module#ServiceSaleSitesModule'
  },
  {
    path: 'saleserviceasset',
    loadChildren: './pages/service-management/sales-service-assets/sales-service-sites.module#ServiceSaleAssetsModule'
  },
  {
    path: 'serviceContracts',
    loadChildren: './pages/service-management/service-contracts/service-contracts.module#ServiceContractsModule'
  },
  {
    path: 'serviceContractsPlus',
    loadChildren: './pages/service-management/service-contracts-plus/service-contracts-plus.module#ServiceContractsPlusModule'
  },
  // {
  //   path: 'editServiceContract',
  //   loadChildren: './pages/service-management/edit-service-contract/edit.service-contract.module#EditServiceContractModule'
  // },
  {
    path: 'serviceQuotes',
    loadChildren: './pages/service-management/service-quotes/service-quotes.module#ServiceQuotesModule'
  },
  {
    path: 'businessStrategy',
    loadChildren: './pages/management/business-strategy/business-strategy.module#BusinessStrategyModule'
  },
  {
    path: 'timeSheet',
    loadChildren: './pages/human-resources/time-sheet/time-sheet.module#TimeSheetModule'
  },
  {
    path: 'runPayroll',
    loadChildren: './pages/human-resources/run-payroll/run-payroll.module#RunPayrollModule'
  },
  {
    path: 'employeeDocuments',
    loadChildren: './pages/human-resources/employee-documents/employee-documents.module#EmployeeDocumentsModule'
  },
  {
    path: 'forms',
    loadChildren: './pages/human-resources/forms/forms.module#FormsModule'
  },
  {
    path: 'projectLaborAnalysis',
    loadChildren: './pages/project-management/project-labor-analysis/project-labor-analysis.module#ProjectLaborAnalysisModule'
  },
  {
    path: 'projectLaborProjection',
    loadChildren: './pages/project-management/project-labor-projection/project-labor-projection.module#ProjectLaborProjectionModule'
  },
  {
    path: 'projectRevenueProjection',
    loadChildren: './pages/project-management/project-revenue-projection/project-revenue-projection.module#ProjectRevenueProjectionModule'
  },
  {
    path: 'employees',
    loadChildren: './pages/human-resources/employees/employees.module#EmployeesModule'
  },
  {
    path: 'myTimeSheet',
    loadChildren: './pages/home/my-time-sheet/my-time-sheet.module#MyTimeSheetModule'
  },
  {
    path: 'Training',
    loadChildren: () => import('./pages/training-video/training-video.module').then(m => m.TrainingVideoModule)
  },
  {
    path: 'myExpenseReports',
    loadChildren: './pages/home/my-expense-reports/my-expense-reports.module#MyExpenseReportsModule'
  },
  {
    path: 'expenseveReport',
    loadChildren: './pages/human-resources/expense-report/expense-report.module#ExpenseReportModule'
  },
  {
    path: 'adminComponent',
    loadChildren: './pages/user-administration/administration-component-dashboard/administration-component-dashboard.module#AdministrationComponentDashboardModule'
  },
  {
    path: 'manageUsers',
    loadChildren: './pages/user-administration/manage-users/manage-users.module#ManageUsersModule'
  },
  {
    path: 'externalUsers',
    loadChildren: './pages/user-administration/external-users/external-users.module#ExternalUsersModule'
  },
  {
    path: 'accountReceivable',
    loadChildren: './pages/accounting/account-receivable/account-receivable.module#AccountReceivableModule'
  },
  {
    path: 'purchaseOrder',
    loadChildren: './pages/inventory/purchase-order/purchase-order.module#PurchaseOrderModule'
  },
  {
    path: 'shipItems',
    loadChildren: './pages/inventory/ship-items/ship-items.module#ShipItemsModule'
  },
  {
    path: 'parts1',
    loadChildren: './pages/inventory/parts/parts.module#PartsModule'
  },
  {
    path: 'parts',
    loadChildren: './pages/inventory/parts/DinamicGridPart/parts.module#PartsModule'
  },
  {
    path: 'subcontractor',
    loadChildren: './pages/inventory/subcontractor/subcontractor.module#SubcontractorModule'
  },
  {
    path: 'deltaWorld',
    loadChildren: './pages/engineering/delta-world/delta-world.module#DeltaWorldModule'
  },
  {
    path: 'programmer',
    loadChildren: './pages/engineering/programmer/programmer.module#ProgrammerModule'
  },
  {
    path: 'prevailingWages',
    loadChildren: './pages/human-resources/prevailing-wages/prevailing-wages.module#PrevailingWagesModule'
  },
  {
    path: 'salesCommission',
    loadChildren: './pages/human-resources/sales-commissioning/sales-commissioning.module#SalesCommissioningModule'
  },
  {
    path: 'myTimeSheet',
    loadChildren: './pages/home/my-time-sheet/my-time-sheet.module#MyTimeSheetModule'
  },
  {
    path: 'myTimeSheetplus',
    loadChildren: './pages/home/my-time-sheet-plus/my-time-sheet.module#MyTimeSheetPlusModule'
  },
  {
    path: 'myCommissions',
    loadChildren: './pages/home/my-commissions/my-commissions.module#MyCommissionsModule'
  },
  {
    path: 'mySchedule',
    // loadChildren: () => import('./pages/home/my-schedule/my-schedule.module').then(m => m.MyScheduleModule)
    loadChildren: './pages/home/my-schedule/my-schedule.module#MyScheduleModule'
    // loadChildren: './pages/project-management/task-management/task-management.module#TaskManagementModule'
  },
  {
    path: 'newActivity',
    loadChildren: './pages/home/new-activity/new-activity.module#NewActivityModule'
  },
  {
    path: 'myInformation',
    loadChildren: './pages/home/my-information/my-information.module#MyInformationModule'
  },
  {
    path: 'systemComponent',
    loadChildren: './pages/engineering/system-components/system-components.module#SystemComponentsModule'
  },
  {
    path: 'vendors',
    loadChildren: './pages/inventory/vendors/vendors.module#VendorsModule'
  },
  {
    path: 'reconcile',
    loadChildren: './pages/inventory/reconcile/reconcile.module#ReconcileModule'
  },
  {
    path: 'rma',
    loadChildren: './pages/inventory/rma/rma.module#RmaModule'
  },
  {
    path: 'serviceManagement',
    loadChildren: './pages/service-management/service-management/service-management.module#ServiceManagementModule'
  },
  {
    path: 'serviceReports',
    loadChildren: './pages/service-management/service-reports/service-reports.module#ServiceReportsModule'
  },
  {
    path: 'departments',
    loadChildren: './pages/management/departments/departments.module#DepartmentsModule'
  },
  {
    path: 'jobDescriptions',
    loadChildren: './pages/management/job-description/job-description.module#JobDescriptionModule'
  },
  {
    path: 'materialRequest',
    loadChildren: './pages/inventory/material-request/material-request.module#MaterialRequestModule'
  },
  {
    path: 'materialrequestplus',
    loadChildren: './pages/inventory/material-request-plus/material-request.module#MaterialRequestModule'
  },
  
  {
    path: 'inventory',
    loadChildren: './pages/inventory/inventory/inventory.module#InventoryModule'
  },
  {
    path: 'trainings',
    loadChildren: './pages/education/trainings/trainings.module#TrainingsModule'
  },
  {
    path: 'editTraining',
    loadChildren: './pages/education/trainings/edit-training/edit-training.module#EditTrainingModule'
  },
  {
    path: 'creditManagement',
    loadChildren: './pages/accounting/credit-management/credit-management.module#CreditManagementModule'
  },
  {
    path: 'importCenter',
    loadChildren: './pages/cube-settings/import-center/import-center.module#ImportCenterModule'
  },
  {
    path: 'updateCenter',
    loadChildren: './pages/cube-settings/update-center/update-center.module#UpdateCenterModule'
  },
  {
    path: 'utilityTables',
    loadChildren: './pages/cube-settings/utility-tables/utility-tables.module#UtilityTablesModule'
  },
  {
    path: 'salesForecast',
    loadChildren: './pages/sales-management/sales-forecast/sales-forecast.module#SalesForecastModule'
  },
  {
    path: 'salesReports',
    loadChildren: './pages/sales-management/sales-reports/sales-reports.module#SalesReportsModule'
  },
  {
    path: 'reports/:departmentid',
    loadChildren: './shared/shared-reports/shared-reports.module#SharedReportsModule'
  },
  {
    path: 'marketAnalysis',
    loadChildren: './pages/sales-management/market-analysis/market-analysis.module#MarketAnalysisModule'
  },
  {
    path: 'marketingCampaign',
    loadChildren: './pages/sales-management/marketing-campaign/marketing-campaign.module#MarketingCampaignModule'
  },
  {
    path: 'integration',
    loadChildren: './pages/cube-settings/integration/integration.module#IntegrationModule'
  },
  {
    path: 'editProject',
    loadChildren: './pages/project-management/edit-project/edit-project.module#EditProjectModule'
  },
  {
    path: 'myEditProject',
    loadChildren: './pages/home/my-edit-project/my-edit-project.module#MyEditProjectModule'
  },
  {
    path: 'editServiceContract',
    loadChildren: './pages/service-management/edit-service-contract/edit-service-contract.module#EditServiceContractModule'
  },
  {
    path: 'editServiceContractPlus',
    loadChildren: './pages/service-management/edit-service-contract-plus/edit-service-contract-plus.module#EditServiceContractPlusModule'
  },
  {
    path: 'editRequisition',
    loadChildren: './pages/project-management/edit-requisition/edit-requisition.module#EditRequisitionModule'
  },
  {
    path: 'partCategories',
    loadChildren: './pages/inventory/part-categories/part-categories.module#PartCategoriesModule'
  },
  {
    path: 'editTechView',
    loadChildren: './pages/engineering/tech-view-delta/edit-tech-view/edit-tech-view.module#EditTechViewModule'
  },
  {
    path: 'configGrid',
    loadChildren: './pages/cube-settings/config-grid/config-grid.module#ConfigGridModule'
  },
  {
    path: 'services-map',
    loadChildren:'./pages/service-management/services-map/map-service/services-map.module#ServicesMapModule'
  },
  {
    path: 'editIntegration',
    loadChildren: './pages/cube-settings/integration/edit-integration/edit-integration.module#EditIntegrationModule'
  },
  {
    path: 'IntegrationQuickbooks',
    loadChildren: './pages/cube-settings/integration/integration-quickbooks/integration-quickbooks.module#IntegrationQuickbooksModule'
  },
  {
    path: 'biAdminComponent',
    loadChildren: './pages/cube-settings/integration/biadmin-component/biadmin-component.module#BiAdminComponentModule'
  },  
  {
    path: 'editEstimate',
    loadChildren: './pages/estimation/edit-estimate/edit-estimate.module#EditEstimateModule'
  },
  {
    path: 'cubeMenu',
    loadChildren: './pages/admin-tools/cube-menu/cube-menu.module#CubeMenuModule'
  },
  {
    path: 'configureImageSVG',
    loadChildren: './pages/admin-tools/configure-image-svg/configure-image-svg.module#ConfigureImageSvgModule'
  },

  // {
  //   path: 'workFlowSummary',
  //   loadChildren: './pages/project-management/edit/work-flow-summary.module#WorkFlowSummaryModule'
  // },
  {
    path: 'workFlowSummary',
    loadChildren: './pages/project-management/work-flow-summary/work-flow-summary.module#WorkFlowSummaryModule'
  },
  {
    path: 'editOpenPunchList',
    loadChildren: './pages/project-management/open-punch-list/edit-open-punch-list/edit-open-punch-list.module#EditOpenPunchListModule'
  },
  {
    path: 'editRif',
    loadChildren: './pages/project-management/open-rif/edit-open-rif/edit-open-rif.module#EditOpenRifModule'
  },
  {
    path: 'editChangeOrder',
    loadChildren: './pages/project-management/edit-project/edit-change-order/edit-change-order.module#EditChangeOrderModule'
  },
  {
    path: 'vehicles',
    loadChildren: './pages/cube-settings/vehicles/vehicles.module#VehiclesModule'
  },
  {
    path: 'editVehicles',
    loadChildren: './pages/cube-settings/vehicles/edit-vehicles/edit-vehicles.module#EditVehiclesModule'
  },
  {
    path: 'recommendations',
    loadChildren: './pages/service-management/service-recommendations/service-recommendations.module#ServiceRecommendationsModule'
  },
  {
    path: 'home',
    loadChildren: './pages/home/home.module#HomeModule'
  },
  {
    path: 'engUtility',
    loadChildren: './pages/engineering/eng-utility/eng-utility.module#EngUtilityModule'
  },
  {
    path: 'groups/:id',
    loadChildren: './pages/user-administration/manage-users/groups/groups.module#GroupsModule'
  },
  {
    path: 'reportviewer',
    loadChildren: 'src/app/shared/report-viewer/report-viewer.module#ReportViewerModule'
  },
  {
    path: 'findReplace',
    loadChildren: './pages/engineering/system-components/find-and-replace/find-and-replace.module#FindAndReplaceModule'
  },
  {
    path: 'unlockUser',
    loadChildren: './pages/admin-tools/unlock-user/unlock-user.module#UnlockUserModule'
  },
  {
    path: 'cubeReleases',
    loadChildren: './pages/admin-tools/cube-releases/cube-releases.module#CubeReleasesModule'
  },
  {
    path: 'clientActivation',
    loadChildren: './pages/admin-tools/client-activation/client-activation.module#ClientActivationModule'
  },
  {
    path: 'clientAdministration',
    loadChildren: './pages/admin-tools/client-administration/client-administration.module#ClientAdministrationModule'
  },
  {
    path: 'responsive',
    loadChildren: './pages/home/responsive/responsive.module#ResponsiveModule'
  },
  {
    path: 'reportdesigner',
    loadChildren: 'src/app/shared/report-designer/report-designer.module#ReportDesignerModule'
  },
  {
    path: 'plans',
    loadChildren: './pages/login/payment/payment.module#PaymentModule'
  },
    {
    path: 'cartPlans',
    loadChildren: './pages/login/card-plans/card-plans.module#CardPlansModule'
  },
  {
    path: 'creditcard',
    loadChildren: './pages/login/creditcard/creditcard.module#CreditCardModule'
  },
  {
    path: 'companyNotification',
    loadChildren: './pages/cube-settings/company-notification/company-notification.module#CompanyNotificationModule'
  },
  {
    path: 'myWebinars',
    loadChildren: 'src/app/pages/start-here/my-webinars/my-webinars.module#MyWebinarsModule'
  },
  {
    path: 'customerWebinars',
    loadChildren: 'src/app/pages/cube-settings/customer-webinars/customer-webinars.module#CustomerWebinarsModule'
  },
  {
    path: 'taskCategory',
    loadChildren: 'src/app/pages/cube-settings/task-category-grid/task-category-grid.module#TaskCategoryGridModule'
  },
  {
    path: 'newAccount',
    loadChildren: 'src/app/pages/login-new-account/login-new-account.module#LoginNewAccountModule'
  },
  {
    path: 'editTransfers',
    loadChildren: 'src/app/pages/inventory/inventory/edit-transfers/edit-transfers.module#EditTransfersModule'
  },
  {
    path: 'editLocationGroup',
    loadChildren: 'src/app/pages/inventory/inventory/edit-location-group/edit-location-group.module#EditLocationGroupModule'
  },
  {
    path: 'editRMA',
    loadChildren: 'src/app/pages/inventory/rma/edit-rma/edit-rma.module#EditRmaModule'
  },
  {
    path: 'editCredit',
    loadChildren: 'src/app/pages/accounting/credit-management/edit-credit-management/edit-credit-management.module#EditCreditManagementModule'
  },
  {
    path: 'kbs',
    loadChildren: 'src/app/pages/education/kbs/kbs.module#KbsModule'
  },
  {
    path: 'editkbas',
    loadChildren: 'src/app/pages/education/kbs/edit-kbas/edit-kbas.module#EditKBAsModule'
  },
  {
    path: 'productsCart',
    loadChildren: 'src/app/pages/shop/products-cart/products-cart.module#ProductsCartModule'
  },
  {
    path: 'productsCategory',
    loadChildren: 'src/app/pages/shop/products-category/products-category.module#ProductsCategoryModule'
  },
  {
    path: 'externaluser',
    loadChildren: './pages/login/register-external-user/register-externa-user.module#RegisterExternaUserModule'
  },
  {
    path: 'clientuser',
    loadChildren: './pages/login/create-client-user/register-client-user.module#RegisterClientUserModule'
  },
  {
    path: 'createuserCW',
    loadChildren: './pages/login/create-cubeworks-user/register-cubeworks-user.module#RegisterCubeWorksUserModule'
  },
  {
    path: 'productsDetails',
    loadChildren: 'src/app/pages/shop/products-details/products-details.module#ProductsDetailsModule'
  },
  {
    path: 'registerCompany',
    loadChildren: './pages/login/register-external-user/register-externa-user.module#RegisterExternaUserModule'
  },
  // {
  //   path: 'companyRegistration',
  //   loadChildren: './pages/login/company-registration/company-registration.module#CompanyRegistrationModule'
  // },
  {
    path: 'paymentCart',
    loadChildren: 'src/app/pages/shop/payment-information/payment-information.module#PaymentInformationModule'
  },
  {
    path: 'newPayment',
    loadChildren: 'src/app/pages/shop/add-new-payment/add-new-payment.module#AddNewPaymentModule'
  },
  {
    path: 'shippingAddress',
    loadChildren: 'src/app/pages/shop/shipping-address/shipping-address.module#ShippingAddressModule'
  },
  {
    path: 'newShippingAddress',
    loadChildren: 'src/app/pages/shop/add-new-shipping/add-new-shipping.module#AddNewShippingModule'
  },
  {
    path: 'order',
    loadChildren: 'src/app/pages/shop/order/order.module#OrderModule'
  },
  {
    path: 'orderDetail',
    loadChildren: 'src/app/pages/shop/order-detail/order-detail.module#OrderDetailModule'
  },
  {
    path: 'applications',
    loadChildren: 'src/app/pages/shop/applications/applications.module#ApplicationsModule'
  },
  {
    path: 'AIShop',
    loadChildren: 'src/app/pages/shop/aiestimateshop/aiestimateshop.module#AIestimateShopModule'
  }, 
  {
    path: 'yourOrder',
    loadChildren: 'src/app/pages/shop/your-order/your-order.module#YourOrderModule'
  },
  {
    path: 'myCart',
    loadChildren: 'src/app/pages/shop/my-cart/my-cart.module#MyCartModule'
  },
  {
    path: 'editExpenseReports',
    loadChildren: './pages/home/my-expense-reports/edit-expense-reports/edit-expense-reports.module#EditExpenseReportsModule'
  },
  {
    path: 'Report',
    loadChildren: './pages/grid-reports/grid-reports.module#GridReportsModule'
  },
  {
    path: 'editExpenseReport',
    loadChildren: './pages/human-resources/expense-report/edit-expense-report/edit-expense-report.module#EditExpenseReportModule'
  },
  {
    path: 'systemlog',
    loadChildren: './pages/admin-tools/system-log/system-log.module#SystemLogModule'
  },
  {
    path: 'projectpart',
    loadChildren: './pages/project-management/projectpart/projectsparts.module#ProjectsPartsModule'
  },
  {
    path: 'reports',
    loadChildren: 'src/app/shared/reports/reports.module#ReportsModule'
  },
  {
    path: 'my-account',
    loadChildren: 'src/app/pages/user-administration/my-account/my-account.module#MyAccountModule'
  },
  {
    path: 'editPayment',
    loadChildren: 'src/app/pages/user-administration/my-account/edit-payment-method/edit-payment-method.module#EditPaymentMethodModule'
  },
  {
    path: 'getMyToken',
    loadChildren: 'src/app/pages/user-administration/gettoken/gettoken.module#GettokenModule'
  },
  {
    path: 'gantt',
    loadChildren: 'src/app/pages/gantt-task/gantt.module#GanttModule'
  },
  {
    path: 'service-gantt',
    loadChildren: 'src/app/pages/gantt-service/gantt-service.module#GanttServiceModule'
  },

  //cube work
  {
    path: 'searchJobs',
    loadChildren: 'src/app/pages/cubeWork/search-job/search-job.module#SearchJobModule'
  },

  {
    path: 'searchJobsNew',
    loadChildren: 'src/app/pages/cubeWork/search-job-new/search-job-new.module#SearchJobNewModule'
  },

  {
    path: 'myFeed',
    loadChildren: 'src/app/pages/cubeWork/my-feed/my-feed.module#MyFeedModule'
  },
  {
    path: 'myFeed2',
    loadChildren: 'src/app/pages/cubeWork/myfeed2/myfeed2.module#Myfeed2Module'
  },
  {
    path: 'clientDashboard',
    loadChildren: 'src/app/pages/cubeWork/client-dasboard/client-dasboard.module#ClientDasboardModule'
  },
  {
    path: 'jobPost',
    loadChildren: 'src/app/pages/cubeWork/job-post/job-post.module#JobPostModule'
  },
  {
    path: 'contracts',
    loadChildren: 'src/app/pages/cubeWork/contracts/contracts.module#ContractsModule'
  },
  {
    path: 'jobs',
    loadChildren: 'src/app/pages/cubeWork/jobs/jobs.module#JobsModule'
  },
  {
    path: 'reviewPost',
    loadChildren: 'src/app/pages/cubeWork/review-post/review-post.module#ReviewPostModule'
  },
  {
    path: 'reportsWork',
    loadChildren: 'src/app/pages/cubeWork/reports-work-cube/reports-work-cube.module#ReportsWorkCubeModule'
  },
  {
    path: 'settings',
    loadChildren: 'src/app/pages/cubeWork/settings-cube-work/settings-cube-work.module#SettingsCubeWorkModule'
  },
  {
    path: 'profileTalent',
    loadChildren: 'src/app/pages/cubeWork/profile-talent/profile-talent.module#ProfileTalentModule'
  },
  {
    path: 'myProposals',
    loadChildren: 'src/app/pages/cubeWork/my-proposals/my-proposals.module#MyProposalsModule'
  },
  {
    path: 'findWork',
    loadChildren: 'src/app/pages/cubeWork/find-work/find-work.module#FindWorkModule'
  },
  {
    path: 'offerView',
    loadChildren: 'src/app/pages/cubeWork/offer-view/offer-view.module#OfferViewModule'
  },
  {
    path: 'detailJobCube',
    loadChildren: 'src/app/pages/cubeWork/detail-job/detail-job.module#DetailJobModule'
  },
  {
    path: 'myJobs',
    loadChildren: 'src/app/pages/cubeWork/my-jobs/my-jobs.module#MyJobsModule'
  },
  {
    path: 'detailsJobs',
    loadChildren: 'src/app/pages/cubeWork/my-jobs-details/my-jobs-details.module#MyJobsDetailsModule'
  },
  {
    path: 'detailsJobsTalent',
    loadChildren: 'src/app/pages/cubeWork/my-jobs-details-talent/my-jobs-details.module#MyJobsDetailsModule'
  },
  {
    path: 'cwUtility',
    loadChildren: 'src/app/pages/cubeWork/cw-utility-tables/cw-utility-tables.module#CWUtilityTablesModule'
  },

  {
    path: 'aiSupport',
    loadChildren: 'src/app/pages/cubeWork/ai-support/ai-support-tables.module#AISupportTablesModule'
  },
  // {
  //   path: 'workflowUtility',
  //   loadChildren: 'src/app/pages/cubeWork/workflow-table/workflow-table.module#workflow-table.module'
  // },

  {
    path: 'NotificationTemplateEmail',
    loadChildren: () => import('./pages/cubeWork/workflow-table/workflow-table.module').then(m => m.WorkFlowTablesModule)
  },

  {
    path: 'chooseSettings',
    loadChildren: 'src/app/pages/cubeWork/choose-settings/choose-settings.module#ChooseSettingsModule'
  },
  {
    path: 'chooseResource',
    loadChildren: 'src/app/pages/admin-tools/choose-resource/choose-resource.module#ChooseResourceModule'
  },
  {
    path: 'submitProposal',
    loadChildren: 'src/app/pages/cubeWork/submit-proposal/submit-proposal.module#SubmitProposalModule'
  },
  {
    path: 'viewProposal',
    loadChildren: 'src/app/pages/cubeWork/view-proposals/view-proposals.module#ViewProposalsModule'
  },
  {
    path: 'viewJobPosting',
    loadChildren: 'src/app/pages/cubeWork/view-job-posting/view-job-posting.module#ViewJobPostingModule'
  },
  {
    path: 'sendanOffer',
    loadChildren: 'src/app/pages/cubeWork/send-offer/send-offer.module#SendOfferModule'
  },
  {
    path: 'message',
    loadChildren: 'src/app/pages/cubeWork/cube-workmessage/cube-workmessage.module#CubeWorkmessageModule'
  },
  {
    path: 'dashboardTalents',
    loadChildren: 'src/app/pages/cubeWork/dashboard-talents/dashboard-talents.module#DashboardTalentsModule'
  },
  {
    path: 'completedJobs',
    loadChildren: 'src/app/pages/cubeWork/completed-jobs/completed-jobs.module#CompletedJobsModule'
  },
  {
    path: 'reviews',
    loadChildren: 'src/app/pages/cubeWork/reviews/reviews.module#ReviewsModule'
  },
  {
    path: 'BillingCW',
    loadChildren:  './pages/cubeWork/billing-cw/billing-cw.module#BillingCWModule'
  },
  {
    path: 'applicant',
    loadChildren: 'src/app/pages/human-resources/applicant/applicant.module#ApplicantModule'
  },
  {
    path: 'editApplicant',
    loadChildren: 'src/app/pages/human-resources/applicant/edit-applicant/edit-applicant.module#EditApplicantModule'
  },
  {
    path: 'editPositions',
    loadChildren: 'src/app/pages/human-resources/applicant/edit-positions/edit-positions.module#EditPositionsModule'
  },
  {
    path: 'cubebox',
    loadChildren: 'src/app/pages/cube-box/cube-box.module#CubeBoxModule'
  },
  {
    path: 'findAndReplaceCubeBox',
    loadChildren: 'src/app/pages/cube-box/find-replace/find-replace.module#FindReplaceModule'
  },
  {
    path: 'cubeboxDiagram',
    loadChildren: 'src/app/pages/cube-box/cube-box-diagram/cube-box-diagram.module#CubeBoxDiagramModule'
  },
  {
    path: 'cubeboxAddToAssets',
    loadChildren: 'src/app/pages/cube-box/add-to-assets/add-to-assets.module#AddToAssetsModule'
  },
  {
    path: 'myActivity',
    loadChildren: './pages/home/my-activity/my-activity.module#MyActivityModule'
  },
  {
    path: 'turnOverSheet',
    loadChildren:'./pages/estimation/estimates/turn-over-sheet-harris/turn-over-sheet-harris.module#TurnOverSheetHarrisModule'
  },
  {
    path: 'dashboardviewer',
    loadChildren:'./pages/dashboard/dashboardBi_windows/dashboard-bi-viewer/dashboard-bi-viewer.module#DashboardBiViewerModule'
  },
  {
    path: 'gatewayAdmin',
    loadChildren: './pages/engineering/gatewayAdmin/gatewayAdmin.module#gatewayAdminModule'
  },
  {
    path: 'tooltip',
    loadChildren: './pages/admin-tools/tooltip/tooltip.module#tooltipModule'
  },
  {
    path: 'videoTutorial',
    loadChildren: './pages/videoTutorial/videoTutorial.module#videoTutorialModule'
  },
  {
    path: 'trainingvideos',
    loadChildren: './pages/admin-tools/trainingvideos/trainingvideos.module#trainingvideosModule'
  },
  {
    path: 'engUtilityMaster',
    loadChildren: './pages/admin-tools/admin-eng-utility/admin-eng-utility.module#AdminEngUtilityModule'
  },
  {
    path: 'systemComponentMaster',
    loadChildren: './pages/admin-tools/admin-eng-utility/system-components-master/system-components-master.module#SystemComponentsMasterModule'
  },
  {
    path: 'systemLibraryMaster',
    loadChildren: './pages/admin-tools/system-library-master/system-library-master.module#SystemLibraryMasterModule'
  },
  {
    path: 'collectImages',
    loadChildren: './pages/machine-learning-images/machine-learning-images.module#MachineLearningImagesModule'
  },
  {
    path: 'menuCube',
    loadChildren: './pages/admin-tools/menu-cube/menu-cube.module#MenuCubeModule'
  }, 
  {
    path: 'ioOptimizer',
    loadChildren: './pages/estimation/io-optimizer/io-optimizer.module#IoOptimizerModule'
  }, 
  {
    path: 'cs-portal',
    loadChildren: './pages/cs-portal/cs-portal.module#CsPortalModule'
  }, 
  {
    path: 'CUBEest',
    loadChildren: './pages/simpleView/simple-view-estimating/simple-view-estimating.module#SimpleViewEstimatingModule'
  },
  {
    path: 'CUBEcx',
    loadChildren: './pages/simpleView/simple-view-commissioning/simple-view-commissioning.module#SimpleViewCommissioningModule'
  }, 
  {
    path: 'adminBilling',
    loadChildren: './pages/admin-tools/adminbilling/adminbilling.module#AdminbillingModule'
  }, 
  {
    path: 'CUBEcxDashboard',
    loadChildren: './pages/simpleView/cubecx-dashboard/cubecx-dashboard.module#CUBEcxDashboardModule'
  },

  {
    path: 'ApplicationType',
    loadChildren: 'src/app/pages/shop/application-type/application-type.module#ApplicationTypeModule'
  },

  {
    path: 'Applicationfiltered',
    loadChildren: 'src/app/pages/shop/application-filtered/application-filtered.module#ApplicationfilteredModule'
  },

  {
    path: 'ListSystems',
    loadChildren: 'src/app/pages/shop/list-systems/list-systems.module#ListSystemsModule'
  },

  {
    path: 'MyProjects',
    loadChildren: 'src/app/pages/shop/my-projects/my-projects.module#MyProjectsModule'
  },
  {
    path: 'DetailProject',
    loadChildren: 'src/app/pages/shop/detail-project/detail-project.module#DetailProjectModule'
  },
  {
    path: 'homeDuplicate',
    loadChildren: 'src/app/home-duplicate/home-duplicate.module#HomeDuplicateModule'
  },
  {
    path: 'cubeAdvertisement',
    loadChildren: 'src/app/pages/cube-settings/cube-advertisement/cube-advertisement.module#CubeAdvertisementModule'
  },
  {
    path: 'AIConsumption',
    loadChildren: 'src/app/pages/cube-settings/aiconsumption/aiconsumption.module#AIConsumptionModule'
  },
  {
    path: 'cubegraphics',
    loadChildren: './pages/engineering/cubegraphics/cubegraphics.module#CubeGraphicsModule'
  },

  {
    path: 'AllProjectShop',
    loadChildren: 'src/app/pages/shop/all-project-cube-shop/all-project-cube-shop.module#AllProjectCubeShopModule'
  },
  {
    path: 'licenseManagment',
    loadChildren: './pages/user-administration/license-management/license-management.module#LicenseManagementModule'
  },
  {
    path: 'issues',
    loadChildren: './pages/home/issues/issues.module#IssuesModule'
  },
  {
    path: 'issuesEmployee',
    loadChildren: './pages/home/issues-employee/issues-employee.module#IssuesEmployeeModule'
  },

  {
    path: 'companyMetrics',
    loadChildren: './pages/admin-tools/company-metrics/company-metrics.module#CompanyMetricsModule'
  },

  {
    path: 'adminMetrics',
    loadChildren: './pages/admin-tools/admin-metrics/admin-metrics.module#AdminMetricsModule'
  },
  {
    path: 'companyCubeScore',
    loadChildren: './pages/cube-score/company-cube-score/company-cube-score.module#CompanyCubeScoreModule'
  },
  {
    path: 'revenueForecast',
    loadChildren: './pages/sales-management/sales-revenue/sales-revenue.module#SalesRevenueModule'
  },
  {
    path: 'companyActivities',
    loadChildren: './pages/home/company-activities/company-activities.module#CompanyActivitiesModule'
  },
  {
    path: 'customerstripesync',
    loadChildren: './pages/cube-settings/integration/customer-stripeintegration/customer-stripeintegration.module#CustomerStripeintegrationModule'
  },
  {
    path: 'adminBotManagement',
    loadChildren: './pages/bot-management/bot-management.module#BotManagementModule'
  },
  {
    path: 'botManagement',
    loadChildren: './pages/bot-management-client/bot-management-client.module#BotManagementClientModule'
  },
  {
    path: 'botChat',
    loadChildren: './shared/chatbot/chatbot.module#ChatbotModule'
  },
  {
    path: 'CompanyEmail',
    loadChildren: () => import('./pages/cubeWork/company-notification-email/company-notification-email.module').then(m => m.CompantNotificationEmailModule)
  },
  {
    path: 'assistantWorkflow',
    loadChildren: './pages/admin-tools/assistant-workflow/assistant-workflow.module#AssistantWorkflowModule'
  },
  {
    path: 'claudeManagement',
    loadChildren: 'src/app/pages/cubeWork/uploadfile-claude/uploadfile-claude.module#UploadfileClaudeModule'
  },
  {
    path: 'claudeChat',
    loadChildren: 'src/app/pages/cubeWork/claude-chat/claude-chat.module#ClaudeChatModule'
  },
  {
    path: 'dispatch',
    loadChildren: './pages/dispatch/dispatch.module#DispatchModule'
  },
  {
    path: 'AIreporting',
    loadChildren: './pages/aireporting-assistant/aireporting-assistant.module#AIreportingAssistantModule'
  },
  {
    path: 'cube-box-edge',
    loadChildren: './pages/cube-box-edge/cube-box-edge.module#CubeBoxEdgeModule'
  },
  {
    path: 'dynamicContent',
    loadChildren: () => import('./pages/dynamic-dashboard/dynamic-dashboard.module').then(m => m.DynamicDashboardModule)
  },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
